// Tour ID constants
export const TOUR_IDS = {
    FIRST_TOUR: 'firstTour',
    WAREHOUSE_TOUR: 'warehouseTour',
    SHIPMENT_TOUR: 'shipmentTour',
    CHARGE_WALLET_TOUR: 'chargeWalletTour',
    PRICE_CALCULATOR_TOUR: 'priceCalculatorTour',
    DOWNLOAD_AWB_TOUR: 'downloadAwbTour',
};

// Re-export all tour steps
export { firstTourSteps } from './firstTour';
export { warehouseTourSteps } from './warehouseTour';
export { shipmentTourSteps } from './shipmentTour';
export { chargeWalletTourSteps } from './chargeWalletTour';
export { priceCalculatorTourSteps } from './priceCalculatorTour';
export { downloadAwbTourSteps, DOWNLOAD_AWB_STEP_INDICES } from './DownloadAwbTour';
